import React, { useEffect, useState } from 'react';
import { sgsstEpp, getSgsstEmpleados } from '../services/api';
import SgsstTabs from '../components/SgsstTabs';
import { S, F, Grid, Grid3, Modal, useFlash, fdate, dateVal } from '../components/sgsstUi';

const MOTIVO = { dotacion: 'Dotación', reposicion: 'Reposición', dano: 'Daño', perdida: 'Pérdida' };
const hoy = () => new Date().toISOString().slice(0, 10);
const VACIO = { empleado_id: '', empleado_nombre: '', epp: '', cantidad: 1, talla: '', fecha_entrega: hoy(), motivo: 'dotacion', fecha_reposicion: '', recibido_conforme: true, observacion: '' };

export default function SgsstEpp() {
  const [lista, setLista] = useState([]);
  const [emp, setEmp] = useState([]);
  const [m, setM] = useState(null);
  const [msgNode, flash] = useFlash();
  const [busy, setBusy] = useState(false);

  const load = () => sgsstEpp.list().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); getSgsstEmpleados().then(r => setEmp(r.data)).catch(() => {}); }, []);

  const pick = (id) => { const e = emp.find(x => x.id === id); setM({ ...m, form: { ...m.form, empleado_id: id, empleado_nombre: e ? e.nombre : m.form.empleado_nombre } }); };
  const guardar = async () => {
    if (!m.form.epp?.trim()) return flash(false, 'Indica el elemento (EPP)');
    if (!m.form.empleado_id && !m.form.empleado_nombre?.trim()) return flash(false, 'Indica el trabajador');
    setBusy(true);
    try { if (m.id) await sgsstEpp.update(m.id, m.form); else await sgsstEpp.create(m.form); setM(null); load(); flash(true, '✅ Guardado'); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo')); } finally { setBusy(false); }
  };
  const borrar = async (r) => { if (!window.confirm('¿Eliminar la entrega?')) return; try { await sgsstEpp.remove(r.id); load(); } catch (e) {} };

  return (
    <div style={S.wrap}>
      <SgsstTabs />
      <div style={S.head}>
        <div><h1 style={S.h1}>Entrega de EPP</h1><p style={S.sub}>Registro de elementos de protección personal entregados.</p></div>
        <button style={S.btn} onClick={() => setM({ form: { ...VACIO } })}>+ Registrar entrega</button>
      </div>
      {msgNode}
      <div style={S.card}><div style={{ overflowX: 'auto' }}>
        <table style={S.table}>
          <thead><tr>{['Fecha', 'Trabajador', 'Elemento', 'Cant.', 'Talla', 'Motivo', 'Conforme', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={8} style={S.empty}>Sin entregas.</td></tr>}
            {lista.map(r => (
              <tr key={r.id}>
                <td style={S.td}>{fdate(r.fecha_entrega)}</td>
                <td style={{ ...S.td, color: '#e2e8f0' }}>{r.empleado_nombre || '—'}</td>
                <td style={S.td}>{r.epp}</td>
                <td style={{ ...S.td, textAlign: 'center' }}>{r.cantidad}</td>
                <td style={S.td}>{r.talla || '—'}</td>
                <td style={S.td}>{MOTIVO[r.motivo] || r.motivo}</td>
                <td style={{ ...S.td, textAlign: 'center' }}>{r.recibido_conforme ? '✔' : '—'}</td>
                <td style={S.td}><button style={S.link} onClick={() => setM({ id: r.id, form: { ...VACIO, ...r, fecha_entrega: dateVal(r.fecha_entrega), fecha_reposicion: dateVal(r.fecha_reposicion) } })}>Editar</button><button style={{ ...S.link, color: '#fca5a5' }} onClick={() => borrar(r)}>Eliminar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>

      {m && <Modal title={m.id ? 'Editar entrega' : 'Registrar entrega de EPP'} onClose={() => setM(null)}>
        <F l="Trabajador">
          <select style={S.in} value={m.form.empleado_id || ''} onChange={e => pick(e.target.value)}>
            <option value="">— Manual —</option>
            {emp.map(e => <option key={e.id} value={e.id}>{e.nombre} · {e.numero_documento}</option>)}
          </select>
        </F>
        {!m.form.empleado_id && <F l="Nombre del trabajador"><input style={S.in} value={m.form.empleado_nombre} onChange={e => setM({ ...m, form: { ...m.form, empleado_nombre: e.target.value } })} /></F>}
        <Grid3>
          <F l="Elemento (EPP)"><input style={S.in} value={m.form.epp} onChange={e => setM({ ...m, form: { ...m.form, epp: e.target.value } })} /></F>
          <F l="Cantidad"><input type="number" style={S.in} value={m.form.cantidad} onChange={e => setM({ ...m, form: { ...m.form, cantidad: +e.target.value } })} /></F>
          <F l="Talla"><input style={S.in} value={m.form.talla} onChange={e => setM({ ...m, form: { ...m.form, talla: e.target.value } })} /></F>
        </Grid3>
        <Grid3>
          <F l="Fecha de entrega"><input type="date" style={S.in} value={m.form.fecha_entrega} onChange={e => setM({ ...m, form: { ...m.form, fecha_entrega: e.target.value } })} /></F>
          <F l="Motivo"><select style={S.in} value={m.form.motivo} onChange={e => setM({ ...m, form: { ...m.form, motivo: e.target.value } })}>{Object.entries(MOTIVO).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
          <F l="Próx. reposición"><input type="date" style={S.in} value={m.form.fecha_reposicion || ''} onChange={e => setM({ ...m, form: { ...m.form, fecha_reposicion: e.target.value } })} /></F>
        </Grid3>
        <Grid>
          <F l="¿Recibido conforme?"><select style={S.in} value={m.form.recibido_conforme ? '1' : '0'} onChange={e => setM({ ...m, form: { ...m.form, recibido_conforme: e.target.value === '1' } })}><option value="1">Sí</option><option value="0">No</option></select></F>
          <F l="Observación"><input style={S.in} value={m.form.observacion} onChange={e => setM({ ...m, form: { ...m.form, observacion: e.target.value } })} /></F>
        </Grid>
        <div style={S.modalBtns}><button style={S.btnGhost} onClick={() => setM(null)}>Cancelar</button><button style={S.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
      </Modal>}
    </div>
  );
}
